import { AttributesMixin, define, Model, type } from "@type-r/models";
import { UnappliedCashPayeesLookup, UnappliedCashPayorsLookup } from "../../api/lookups";
import { UnappliedCashFilter } from "./unapplied-cash-filter";

export interface UnappliedCashStore extends AttributesMixin<typeof UnappliedCashStore> { }
@define
export class UnappliedCashStore extends Model {
    static attributes = {
        filter: type(UnappliedCashFilter),
        payors: UnappliedCashPayorsLookup,
        payees: UnappliedCashPayeesLookup
    }

    initialize() {
        this.filter.payors.set({
            selected: [],
            placeholder: 'Payor Name',
            options: Array.from(new Set(this.payors.items.map(x => x.name)))
        })
        this.filter.payees.set({
            selected: [],
            placeholder: 'Payee Name',
            options: Array.from(new Set(this.payees.items.map(x => x.name)))
        })
    }
}